export const FORM_TABS = ['Summary'];

